import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Global composable that provides access to global actions and state
 */
export function useGlobal() {
  const store = useStore();

  // Global getters
  const pageTitle = computed(() => store.getters['global/GET_PAGE_TITLE']);
  const isIeOrEdge = computed(() => store.getters['global/GET_IS_IE_OR_EDGE']);
  const isAdminView = computed(() => store.getters['global/GET_IS_ADMIN_VIEW']);
  const isNotFoundView = computed(() => store.getters['global/GET_IS_NOTFOUND_VIEW']);
  const hideMaintenanceBanner = computed(() => store.getters['global/GET_HIDE_MAINTENANCE_BANNER']);
  const isSiteNotAvailable = computed(() => store.getters['global/GET_IS_SITE_NOT_AVAILABLE']);
  const hideBrowserBanner = computed(() => store.getters['global/GET_HIDE_BROWSER_BANNER']);
  const showMGMjoinLinkErrorModal = computed(() => store.getters['global/GET_SHOW_MGM_JOIN_LINK_ERROR_MODAL']);
  const isMeetingEnded = computed(() => store.getters['global/GET_IS_MEETING_ENDED']);

  // Global actions
  const displaySystemMessage = (message) => store.dispatch('global/displaySystemMessage', message);
  const displaySystemErrorMessage = (message) => store.dispatch('global/displaySystemErrorMessage', message);
  const setHideMaintenanceBanner = (hideBanner) => store.dispatch('global/setHideMaintenanceBanner', hideBanner);
  const setHideBrowserBanner = (hideBanner) => store.dispatch('global/setHideBrowserBanner', hideBanner);
  const setIsIeOrEdge = (isIeOrEdge) => store.dispatch('global/setIsIeOrEdge', isIeOrEdge);
  const setShowMGMjoinLinkErrorModal = (modal) => store.dispatch('global/setShowMGMjoinLinkErrorModal', modal);
  const setPageTitle = (title) => store.dispatch('global/setPageTitle', title);


  return {
    // Getters
    pageTitle,
    isIeOrEdge,
    isAdminView,
    isNotFoundView,
    hideMaintenanceBanner,
    isSiteNotAvailable,
    hideBrowserBanner,
    showMGMjoinLinkErrorModal,
    isMeetingEnded,
    
    // Actions
    displaySystemMessage,
    displaySystemErrorMessage,
    setHideMaintenanceBanner,
    setHideBrowserBanner,
    setIsIeOrEdge,
    setShowMGMjoinLinkErrorModal,
    setPageTitle
  };
}
